<div class="container">
    <div class="menu" #userMenu>
        <a (click)="itemSelected('home')" class="logo"><img src="assets/img/CALogoWhiteHeader.png"></a>
        @if(isSignedIn) {
        @if(showAll){
        <div class="base">
            <div class="items-lhs">
                @if(assignedWorkOptions) {
                <app-cf-dropdown [options]="assignedWorkOptions"
                    (parentSelected)="itemSelected('assigned')"></app-cf-dropdown>
                }
                @if(interviewerActions) {
                <app-cf-dropdown [options]="interviewerActions"
                    (dropdownSelected)="dropdownSelected($event)"></app-cf-dropdown>
                }
                @if(interviewerOptions) {
                <app-cf-dropdown [options]="interviewerOptions"
                    (dropdownSelected)="dropdownSelected($event)"></app-cf-dropdown>
                }
                @if(dropdownOptions) {
                <app-cf-dropdown [options]="dropdownOptions"
                    (dropdownSelected)="dropdownSelected($event)"></app-cf-dropdown>
                }
            </div>
            <div class="items-rhs">
                <div class="search">
                    <app-cf-typeahead #typeahead [placeholderTextDefault]="'Search'"
                        [placeholderTextActive]="'Name, Email, Application ID'" [isSearching]="isTypeaheadSearching"
                        [hasResults]="true" (lookup)="doTypeaheadLookup($event)"
                        (onFocus)="onSearchFocus()">
                        <div results>
                            <div class="search-results-container">
                                <!-- Tab selector -->
                                <div class="search-tab-selector">
                                    <span class="search-tab"
                                        [class.active-search-tab]="selectedTab === 'applicant'"
                                        [class.inactive-search-tab]="selectedTab !== 'applicant'"
                                        (click)="selectTab('applicant')">Applicant</span>
                                    <span class="search-tab"
                                        [class.active-search-tab]="selectedTab === 'interviewer'"
                                        [class.inactive-search-tab]="selectedTab !== 'interviewer'"
                                        (click)="selectTab('interviewer')">Interviewer</span>
                                </div>

                                @if(currentSearchText.length < 3) {
                                <div class="search-instructions subtle">
                                    Enter a name or email to begin searching.
                                </div>
                                }

                                @if(currentSearchText.length > 2 && isTypeaheadSearching) {
                                <div class="search-loading">
                                    <app-cf-loader [size]="LoaderSize.Small" [style]="LoaderStyle.Circles" [color]="LoaderColor.Black"></app-cf-loader>
                                </div>
                                }

                                @if(currentSearchResultsForText === currentSearchText) {
                                    <!-- Applicant results -->
                                    @if(selectedTab === 'applicant' && !isTypeaheadSearching && alreadySearched) {
                                    <div class="app-container">
                                        <div class="app-grid">
                                            @for(result of typeaheadSearchResults; track result.applicationId) {
                                            <div class="applicant" (click)="selectSearchResult(result)">
                                                <div class="app-status" [ngClass]="getStatusClass(result.userState)"></div>
                                                <div class="app-image">
                                                    <app-round-image [url]="result.profileImageUri || ''" [width]="44" [height]="44"></app-round-image>
                                                </div>
                                                <div class="app-name">{{ result.firstName }} {{ result.lastName }}</div>
                                                <div class="app-email">{{ result.email }}</div>
                                                @if(result.bookmarkId) {
                                                <div class="app-bookmark">
                                                    <i class="fa-solid fa-bookmark"></i>
                                                </div>
                                                }
                                            </div>
                                            }
                                        </div>
                                        @if(typeaheadSearchResults.length === 0) {
                                        <div class="no-results">
                                            Sorry! Can't find any applicant that would match your query.
                                        </div>
                                        }
                                    </div>
                                    }

                                    <!-- Interviewer results -->
                                    @if(selectedTab === 'interviewer' && !isTypeaheadSearching && alreadySearched) {
                                    <div class="int-container">
                                        <div class="int-grid">
                                            @for(interviewer of interviewerSearchResults; track interviewer.id) {
                                            <div class="interviewer" (click)="selectInterviewer(interviewer)">
                                                <div class="int-image">
                                                    <app-round-image [url]="interviewer.profileURL || ''" [width]="44" [height]="44"></app-round-image>
                                                </div>
                                                <div class="int-name">{{ interviewer.firstName }} {{ interviewer.lastName }}</div>
                                                <div class="int-email">{{ interviewer.email }}</div>
                                            </div>
                                            }
                                        </div>
                                        @if(interviewerSearchResults.length === 0) {
                                        <div class="no-results">
                                            Sorry! Can't find any interviewer that would match your query.
                                        </div>
                                        }
                                    </div>
                                    }
                                }

                                <!-- Recently viewed -->
                                @if(canShowHistory()) {
                                    <div class="search-results-header">
                                        <strong>Recently viewed</strong>
                                    </div>
                                    @if(selectedTab === 'applicant') {
                                    <div class="app-container">
                                        <div class="app-grid">
                                            @for(applicant of recentlyViewedApplicants; track applicant.applicantId) {
                                            <div class="applicant" (click)="selectRecentlyViewed(applicant)">
                                                <div class="app-status" [ngClass]="getStatusClass(applicant.userState)"></div>
                                                <div class="app-image">
                                                    <app-round-image [url]="applicant.profileImageUri || ''" [width]="44" [height]="44"></app-round-image>
                                                </div>
                                                <div class="app-name">{{ applicant.firstName }} {{ applicant.lastName }}</div>
                                                <div class="app-email">{{ applicant.email }}</div>
                                                @if(applicant.bookmarkId) {
                                                <div class="app-bookmark">
                                                    <i class="fa-solid fa-bookmark"></i>
                                                </div>
                                                }
                                            </div>
                                            }
                                        </div>
                                    </div>
                                    }
                                }
                            </div>
                        </div>
                    </app-cf-typeahead>
                </div>
                <div class="user">
                    <span class="name">{{userName}}</span>
                    @if(userOptions) {
                    <app-cf-dropdown class="user-menu" [options]="userOptions"
                        (dropdownSelected)="dropdownSelected($event)"></app-cf-dropdown>
                    }
                </div>
            </div>
        </div>
        }
        }
    </div>
</div>
<div class="container-compact">
    <div class="menu">
        <a (click)="itemSelected('home')" class="logo"><img src="assets/img/CALogoWhiteShortHeader.png"></a>
        @if(userOptions) {
        <app-cf-dropdown class="user-menu" [options]="userOptions"
            (dropdownSelected)="dropdownSelected($event)"></app-cf-dropdown>
        }
    </div>
</div>